import './styles/mission.css'
function Mission() {
    return (
        <div className="mission-container">
            <div className="mission">
                <h2>La mission di HEQA</h2>
                <p>HEQA è la piattaforma pensata per gli artisti che vogliono trasformare la loro popolarità in un'opportunità di guadagno concreta.</p>
                <p> Connettersi con i fan non è mai stato così semplice: offri contenuti esclusivi, stabilisci il valore del tuo tempo e inizia a monetizzare senza intermediari. </p>
                <p>HEQA ti dà il controllo totale sulla tua carriera, con pagamenti sicuri e un sistema intuitivo per gestire le richieste.</p>
            </div>
            <img alt="ciao" src="https://images.pexels.com/photos/9008750/pexels-photo-9008750.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" />
        </div>
    )

}

export default Mission